import { render, staticRenderFns } from "./ChatClosingMessage.vue?vue&type=template&id=310a1a51&scoped=true&"
import script from "./ChatClosingMessage.vue?vue&type=script&lang=js&"
export * from "./ChatClosingMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatClosingMessage.vue?vue&type=style&index=0&id=310a1a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a1a51",
  null
  
)

export default component.exports